export const SERVICES_DATA = {
  patents: {
    number: "01",
    title: "Patent",
    accent: "Services",
    seoDescription: "Complete patent lifecycle support — analytics, drafting, filing and prosecution across every technology domain. PCT international filing and national phase entry by ClaimSpace LegalTech.",
    intro: "Complete patent lifecycle support — from early-stage analytics to grant and post-grant management — across every technical domain.",
    chips: ["PCT & National Phase", "All Technology Domains", "FER & Office Actions", "Renewals & Annuities"],
    ctaNoun: "invention",
    groups: [
      {
        title: "Patent Analytics & Search",
        items: [
          "Patentability / Novelty Search — assessing whether an invention is new and non-obvious over existing prior art",
          "Freedom-to-Operate (FTO) Search — analysing whether a product or process can be commercialised without infringing third-party patents",
          "Prior Art / Invalidation Search — supporting oppositions, litigation and revocation proceedings",
          "Patent Landscape Analysis — mapping technology trends, white spaces and competitor activity",
          "Patent Portfolio Analysis & Valuation",
          "State-of-the-Art / Novelty Reports for R&D teams",
          "Patent Watch / Monitoring services for competitors and technology areas",
        ],
      },
      {
        title: "Patent Drafting & Filing — All Domains",
        items: [
          "Provisional and Complete Specification Drafting",
          "Filing in every technology domain — Mechanical, Electrical & Electronics, Computer Science / Software, Telecommunications, Chemistry, Biotechnology, Pharmaceuticals, Medical Devices and more",
          "PCT (International) Patent Filing and National Phase Entry",
          "Claim Drafting and Claim Chart Preparation",
          "Design-around and Invention Disclosure support",
        ],
      },
      {
        title: "Patent Prosecution",
        items: [
          "Responding to First Examination Reports (FER) and Office Actions",
          "Hearing Support and Representation before the Patent Office",
          "Amendments, Pre-Grant and Post-Grant Opposition support",
          "Patent Grant follow-up and Renewal / Annuity management",
        ],
      },
      {
        title: "Proofreading, Formatting & Job Work",
        items: [
          "Patent Specification Proofreading and Quality Checks",
          "Formatting of specifications, claims and drawings as per patent office standards",
          "Figure / Drawing preparation as per patent office norms",
          "Outsourced job-work support for law firms and corporate IP departments — on a project or retainer basis",
        ],
      },
    ],
  },
  trademarks: {
    number: "02",
    title: "Trademark",
    accent: "Services",
    seoDescription: "Trademark search, filing, prosecution, opposition, watch and renewal services — word marks, logos, device and series marks by ClaimSpace LegalTech.",
    intro: "From clearance search to registration and beyond — your brand searched, filed, prosecuted and watched, with full representation before the trademark registry.",
    chips: ["Availability Search", "Word & Device Marks", "Hearings & Opposition", "Watch & Renewal"],
    ctaNoun: "brand",
    groups: [
      {
        title: "End-to-End Trademark Practice",
        items: [
          "Search & Availability Analysis — comprehensive search prior to filing",
          "Filing & Registration — word marks, logos, device marks, series marks",
          "Prosecution — responding to examination reports and objections",
          "Hearing Representation & Opposition — legal representation before the trademark registry",
          "Maintenance & Watch — trademark renewals, portfolio management and trademark watch services",
          "Commercial IP — trademark assignment and licensing agreements",
        ],
      },
    ],
  },
  designs: {
    number: "03",
    title: "Design",
    accent: "Registration",
    seoDescription: "Design search, application drafting, filing, prosecution and renewal of registered designs by ClaimSpace LegalTech.",
    intro: "The way your product looks is property too. We search, draft, file, prosecute and renew registered designs so your aesthetic edge stays yours.",
    chips: ["Novelty Assessment", "Application Drafting", "Office Action Response", "Portfolio Management"],
    ctaNoun: "design",
    groups: [
      {
        title: "Registered Design Practice",
        items: [
          "Design Search and Novelty Assessment",
          "Design Application Drafting and Filing",
          "Design Prosecution and Office Action Response",
          "Design Renewal and Portfolio Management",
        ],
      },
    ],
  },
  copyrights: {
    number: "04",
    title: "Copyright",
    accent: "Services",
    seoDescription: "Copyright registration for literary, artistic, software, musical and cinematographic works, plus assignment, licensing and infringement support by ClaimSpace LegalTech.",
    intro: "Registration and commercial management of creative and software works — from first draft to licensing deal and infringement response.",
    chips: ["Software & Literary Works", "Assignment & Licensing", "Infringement Support"],
    ctaNoun: "work",
    groups: [
      {
        title: "Copyright Practice",
        items: [
          "Copyright Registration — literary, artistic, software, musical and cinematographic works",
          "Copyright Assignment and Licensing Agreements",
          "Copyright Infringement Analysis and Support",
        ],
      },
    ],
  },
  "patent-analytics": {
    number: "05",
    title: "Patent",
    accent: "Analytics",
    seoDescription: "Patentability, freedom-to-operate, landscape and invalidation studies, portfolio valuation and patent watch services by ClaimSpace LegalTech.",
    intro: "Decision-grade intelligence for R&D, investors and legal teams — know what exists, what is free, and what your portfolio is worth before you spend.",
    chips: ["Patentability & Novelty", "FTO Analysis", "Landscape Mapping", "Portfolio Valuation"],
    ctaNoun: "portfolio",
    groups: [
      {
        title: "Analytics & Intelligence",
        items: [
          "Patentability / Novelty Search — is the invention new and non-obvious?",
          "Freedom-to-Operate (FTO) Search — can it be commercialised without infringing?",
          "Prior Art / Invalidation Search — ammunition for oppositions, litigation and revocation",
          "Patent Landscape Analysis — technology trends, white spaces and competitor activity",
          "Patent Portfolio Analysis & Valuation",
          "State-of-the-Art / Novelty Reports for R&D teams",
          "Patent Watch / Monitoring — competitors and technology areas under continuous watch",
        ],
      },
    ],
  },
  "job-work": {
    number: "06",
    title: "Job-Work",
    accent: "Support",
    seoDescription: "Dedicated outsourced IP support for law firms and corporate IP departments — drafting, proofreading, formatting and filing assistance on project or retainer basis by ClaimSpace LegalTech.",
    intro: "Dedicated outsourced IP support for law firms and corporate IP departments — your overflow, handled by specialists, on a project or retainer basis.",
    chips: ["For Law Firms", "For IP Departments", "Project or Retainer", "Strict Confidentiality"],
    ctaNoun: "caseload",
    groups: [
      {
        title: "Outsourced IP Job Work",
        items: [
          "Patent Specification Drafting support",
          "Proofreading and Quality Checks",
          "Formatting of specifications, claims and drawings as per patent office standards",
          "Figure / Drawing preparation as per patent office norms",
          "Filing assistance and docketing support",
          "Flexible engagement — per project or monthly retainer",
        ],
      },
      {
        title: "Advisory & Other IPR Services",
        items: [
          "IP Licensing, Assignment and Technology Transfer Agreements",
          "IP Due Diligence for Mergers, Acquisitions and Investments",
          "IP Litigation and Enforcement Support",
          "IP Portfolio Management and Strategy Consulting",
          "IPR Training Workshops and Awareness Programs",
          "Any other IPR-related job-work / outsourced service as required",
        ],
      },
    ],
  },
};
